import request from './request'
import config from '@/config'

// data是post专用，params是get专用

// 获取游戏信息用户客服聊天
export function fetchMemberDetail(params = {}) {
  return request({
    url: `${config.apiBaseUrl}/cs/api/detail`,
    method: 'get',
    params
  })
}

// 客服配置地址
export function fetchConfig() {
  return Promise.resolve({
    svflag: 0,
    msg: 'success',
    data: {
      socketUrl: config.socketUrl,
      uploadImageUrl: config.uploadImageUrl
    }
  })
}

// 设置客服快捷回复
export function setCsQuickReply(data = {}) {
  return request({
    url: `${config.apiBaseUrl}/cs/api/setCsQuickReply`,
    method: 'post',
    data
  })
}

// 客服快捷回复
export function getCsQuickReply(params = {}) {
  return request({
    url: `${config.apiBaseUrl}/cs/api/getCsQuickReply`,
    method: 'get',
    params
  })
}

// 用户其他信息
export function getCsUserInfo(data = {}) {
  return request({
    url: `${config.apiBaseUrl}/cs/api/getCsUserInfo`,
    method: 'post',
    data
  })
}

// 更新用户其他信息
export function updateUserinfo(data = {}) {
  return request({
    url: `${config.apiBaseUrl}/cs/api/updateUserinfo`,
    method: 'post',
    data
  })
}
